export function winToUnix(path) {
    return '/' + path.replace(/\\/g, '/');
}
export function unixToWin(path) {
    path = path.replace(/^\//, '').replace(/\//g, '\\');
    if (!path) {
        path = '\\';
    }
    else if (path.match(/^[a-zA-Z]:$/)) {
        path += '\\';
    }
    return path;
}
